import Vue from 'vue'
import Websocket from './websocket.js'
import { ACCESS_TOKEN } from '@/store/mutation-types'
const state = {
    websock: null,	// websock变量
    header: {},
    messageMap: {},	// onmessage 返回的数据
}

// getters.js
const getters = {
    messageMap(state) {
        return state.messageMap
    },
    websock(state) {
        return state.websock
    }
}
const mutations = {
    updateMessage(state, payload) {
        Vue.set(state.messageMap, payload['key'], payload['list'])
    },
    //  websocket初始化
    updateWebsocket(state, header) {
        if (!state.websock) {
            state.websock = new Websocket({ header: header })
            state.messageMap = {}
        }
    },
    updateHeader(state, data) {
        state.header = data
    }
}

// actions 改变状态的操作
const actions = {
    connect({ commit }, header) {
        const token = Vue.ls.get(ACCESS_TOKEN)
        const userInfo = Vue.ls.get('USER_INFO')
        const headerDefault = {
            businessType: '0', // 暂时默认0
            businessKey: '', // 业务逻辑key
            userType: '1',
            token: token, // 携带客户端信息
            userId: userInfo ? userInfo.id : ''
        }
        const headerConnect = { ...headerDefault, ...header }
        commit('updateHeader', headerConnect)
        if (!state.websock) {
            // 初始化websocket
            commit('updateWebsocket', headerConnect)
        } else {
            // 重新connect，目前只支持单个websocket
            state.websock.disconnect()
            // 销毁实例对象
            state.websock = null
            commit('updateWebsocket', headerConnect)
        }
    },
    // 发送消息
    sendMessage({ commit }, { destination, message }) {
        const _msg = JSON.stringify(message)
        state.websock.send(destination, _msg)
    },
    // 断开连接
    disconnect() {
        if (state.websock) {
            state.websock.disconnect()
        }
    },
    // 订阅消息
    subscribe({ commit }, { destination, callback, isSaveVuex }) {
        if (!state.websock) {
            return
        }
        state.websock.subscribe(destination, (data) => {
            if (isSaveVuex) {
                // 保存在vuex
                const desState = state.messageMap[destination] || []
                desState.push(data)
                commit('updateMessage', { key: destination, list: desState })
                console.log('updateMessage', state.messageMap[destination])
            }
            callback(data)
        })
    },
    // 取消订阅
    unsubscribe({ commit }, destination) {
        if (state.websock) {
            state.websock.unsubscribe(destination)
        }
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
